import AccountProvider from "../resource/account";

const AccountService = new AccountProvider();

const state = {
    items: [],
    platforms: [],
    records: [],
    recordsPagination: {
        total: 0,
        page: 1,
        per_page: 50
    },
    reportSummary: null,
    reportByUser: [],
    reportByItem: [],
    reportByDate: []
};

const getters = {
    getItems: state => state.items,
    getPlatforms: state => state.platforms,
    getRecords: state => state.records,
    getRecordsPagination: state => state.recordsPagination,
    getReportSummary: state => state.reportSummary,
    getReportByUser: state => state.reportByUser,
    getReportByItem: state => state.reportByItem,
    getReportByDate: state => state.reportByDate
};

const mutations = {
    SET_ITEMS(state, data) {
        state.items = data;
    },
    SET_PLATFORMS(state, data) {
        state.platforms = data;
    },
    SET_RECORDS(state, data) {
        state.records = data.records || [];
        state.recordsPagination = {
            total: data.total || 0,
            page: data.page || 1,
            per_page: data.per_page || 50
        };
    },
    SET_REPORT_SUMMARY(state, data) {
        state.reportSummary = data;
    },
    SET_REPORT_BY_USER(state, data) {
        state.reportByUser = data;
    },
    SET_REPORT_BY_ITEM(state, data) {
        state.reportByItem = data;
    },
    SET_REPORT_BY_DATE(state, data) {
        state.reportByDate = data;
    }
};

const actions = {
    // Account Items
    async listItems({ commit }, params) {
        try {
            const response = await AccountService.ItemList(params);
            commit("SET_ITEMS", response.data.Data || []);
            return response;
        } catch (error) {
            commit("SET_ITEMS", []);
            throw error;
        }
    },

    async listPlatforms({ commit }) {
        try {
            const response = await AccountService.PlatformList();
            commit("SET_PLATFORMS", response.data.Data || []);
            return response;
        } catch (error) {
            commit("SET_PLATFORMS", []);
            throw error;
        }
    },

    getItemDetail({ commit }, id) {
        return AccountService.ItemDetail(id);
    },

    createItem({ commit }, params) {
        return AccountService.ItemCreate(params);
    },

    updateItem({ commit }, { id, payload }) {
        return AccountService.ItemUpdate(id, payload);
    },

    deleteItem({ commit }, id) {
        return AccountService.ItemDelete(id);
    },

    // Account Records
    async listRecords({ commit }, params) {
        try {
            const response = await AccountService.RecordList(params);
            const data = response.data.Data && response.data.Data[0] ? response.data.Data[0] : { records: [], total: 0, page: 1, per_page: 50 };
            commit("SET_RECORDS", data);
            return response;
        } catch (error) {
            commit("SET_RECORDS", { records: [], total: 0, page: 1, per_page: 50 });
            throw error;
        }
    },

    getRecordDetail({ commit }, id) {
        return AccountService.RecordDetail(id);
    },

    createRecord({ commit }, params) {
        return AccountService.RecordCreate(params);
    },

    updateRecord({ commit }, { id, payload }) {
        return AccountService.RecordUpdate(id, payload);
    },

    deleteRecord({ commit }, id) {
        return AccountService.RecordDelete(id);
    },

    createRecordBatch({ commit }, params) {
        return AccountService.RecordCreateBatch(params);
    },

    // Record Documents
    listRecordDocuments({ commit }, recordId) {
        return AccountService.RecordDocumentList(recordId);
    },

    uploadRecordDocument({ commit }, { recordId, formData }) {
        return AccountService.RecordDocumentUpload(recordId, formData);
    },

    getRecordDocumentUrl({ commit }, { recordId, docId }) {
        return AccountService.RecordDocumentUrl(recordId, docId);
    },

    deleteRecordDocument({ commit }, { recordId, docId }) {
        return AccountService.RecordDocumentDelete(recordId, docId);
    },

    // Reports
    async fetchReportSummary({ commit }, params) {
        try {
            const response = await AccountService.ReportSummary(params);
            const data = response.data.Data && response.data.Data[0] ? response.data.Data[0] : null;
            commit("SET_REPORT_SUMMARY", data);
            return response;
        } catch (error) {
            commit("SET_REPORT_SUMMARY", null);
            throw error;
        }
    },

    async fetchReportByUser({ commit }, params) {
        try {
            const response = await AccountService.ReportByUser(params);
            commit("SET_REPORT_BY_USER", response.data.Data || []);
            return response;
        } catch (error) {
            commit("SET_REPORT_BY_USER", []);
            throw error;
        }
    },

    async fetchReportByItem({ commit }, params) {
        try {
            const response = await AccountService.ReportByItem(params);
            commit("SET_REPORT_BY_ITEM", response.data.Data || []);
            return response;
        } catch (error) {
            commit("SET_REPORT_BY_ITEM", []);
            throw error;
        }
    },

    async fetchReportByDate({ commit }, params) {
        try {
            const response = await AccountService.ReportByDate(params);
            commit("SET_REPORT_BY_DATE", response.data.Data || []);
            return response;
        } catch (error) {
            commit("SET_REPORT_BY_DATE", []);
            throw error;
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
